import { API_CONFIG, getApiUrl, getAuthHeaders } from '../config/api';
import type { SessionUser } from './session';

export interface GoogleAuthResult {
  token?: string;
  expiresAt?: string;
  user?: SessionUser;
  status?: 'pending';
  connected?: boolean;
}

export async function googleStaffAuth(path: string, token?: string, body?: object): Promise<GoogleAuthResult> {
  const popup = window.open('about:blank', 'clinix-google', 'width=520,height=720');
  if (!popup) throw new Error('popupBlocked');
  return new Promise((resolve, reject) => {
    let finished = false;
    const finish = (result?: GoogleAuthResult, error?: string) => {
      if (finished) return;
      finished = true;
      window.removeEventListener('message', receive);
      window.clearInterval(closedTimer);
      window.clearTimeout(timeout);
      popup.close();
      if (error) reject(new Error(error)); else resolve(result || {});
    };
    const receive = (event: MessageEvent) => {
      if (event.origin !== new URL(API_CONFIG.BASE_URL, window.location.origin).origin || event.source !== popup || event.data?.type !== 'clinix-google') return;
      finish(event.data.result, event.data.error);
    };
    window.addEventListener('message', receive);
    const closedTimer = window.setInterval(() => { if (popup.closed) finish(undefined, 'googleConsentDenied'); }, 1000);
    const timeout = window.setTimeout(() => finish(undefined, 'oauthStateInvalid'), 10 * 60 * 1000);
    fetch(getApiUrl(path), {
      method: path === '/calendar/authorize' ? 'GET' : 'POST', credentials: 'include',
      headers: token ? getAuthHeaders(token) : { 'Content-Type': 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    }).then(async response => {
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'googleAuthorizationFailed');
      if (!finished) popup.location.href = data.authUrl;
    }).catch(error => finish(undefined, error instanceof Error ? error.message : 'googleAuthorizationFailed'));
  });
}
